import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/start")({
  validateSearch: (search: Record<string, unknown>) => ({
    email: typeof search.email === "string" ? search.email : undefined,
  }),
  beforeLoad: ({ search }) => {
    // Legacy route — preserved to keep magic links in old welcome emails working.
    // Funnel everything through /signin, which is the canonical sign-in surface.
    throw redirect({
      to: "/signin",
      search: search.email ? { email: search.email } : {},
    });
  },
  component: () => null,
});
